import { NEO_HOST_NAMES } from "./const";

export const isNeoControlPanel = NEO_HOST_NAMES.includes(window.location.hostname);
